var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 40 40"}},_vm.$listeners),[_c('path',{attrs:{"d":"M17.723 12.411a5.313 5.313 0 10.001 10.625 5.313 5.313 0 00-.001-10.625m0 13.66a8.349 8.349 0 117.224-4.16l5.678 5.678a3.036 3.036 0 01-3.036 3.036l-5.678-5.678a8.313 8.313 0 01-4.188 1.124"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }